// react-native shim for the web build. vite.config aliases the bare
// "react-native" specifier to THIS file (not directly to react-native-web), so
// every `import { Text } from "react-native"` — app code and workspace packages
// alike — gets react-native-web with one change: Text and TextInput default to
// the brand font.
//
// Why a shim instead of a runtime patch (as on mobile): on web the ESM module
// namespace is frozen, so the Object.defineProperty approach in
// @heraion/ui/installGlobalFont can't run. The app sets fontFamily on almost
// no Text node, and react-native-web's Text otherwise defaults to its built-in
// System font stack, so without this the brand font never applies.
//
// The font value is read from @heraion/shared (the web CSS stack) rather than
// @heraion/ui to avoid an import cycle: @heraion/ui imports "react-native",
// which resolves back to this shim.
import React from "react";
import { typography } from "@heraion/shared";
import * as RNW from "react-native-web";

export * from "react-native-web";

const base = { fontFamily: typography.fonts.sans };

function withFont<P extends { style?: unknown }>(
  Original: React.ComponentType<P>,
  label: string,
): React.ComponentType<P> {
  const Wrapped = React.forwardRef<unknown, P>((props, ref) =>
    React.createElement(Original, {
      ...props,
      ref,
      style: [base, props.style],
    } as P),
  );
  (Wrapped as { displayName?: string }).displayName = `Font(${label})`;
  return Wrapped as unknown as React.ComponentType<P>;
}

// Named overrides win over the `export *` re-export above.
export const Text = withFont(
  RNW.Text as unknown as React.ComponentType<{ style?: unknown }>,
  "Text",
);
export const TextInput = withFont(
  RNW.TextInput as unknown as React.ComponentType<{ style?: unknown }>,
  "TextInput",
);
